import { DATA_PART_1 } from './data_chunk1';
import { DATA_PART_2 } from './data_chunk2';
import { DATA_PART_3 } from './data_chunk3';

export const RAW_DATA = DATA_PART_1 + DATA_PART_2 + DATA_PART_3;
